import React, { FC } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { KButton, KSpan, KTooltip } from "kahuna-base-react-components"

import "./CoManagerButton.css"
import { lang } from "../../../constants/languages"

const CO_MANAGER_PATH = "/co-manager"

/**
 * The Co-Manager shortcut that sits to the left of the notification bell.
 *
 * Rendered only for an account that has the permission, the same rule the sidebar item and the route
 * guard use: without it the click would land on the not found page.
 */
const CoManagerButton: FC = () => {
  const navigate = useNavigate()
  const onCoManagerPage = useLocation().pathname.startsWith(CO_MANAGER_PATH)

  return (
    <KTooltip
      backgroundColor="#000"
      arrowColor="#000"
      padding="0px 4px"
      height="20px"
      position="bottom"
      content={
        <div className="h-5 w-max flex items-center">
          <KSpan text={lang.navigation.co_manager} fontSize={12} lineHeight="16px" color="#FFF" />
        </div>
      }
    >
      <div className={`co-manager-header-button${onCoManagerPage ? " co-manager-header-button-still" : ""}`}>
        <KButton
          dataTestId="header-co-manager-button"
          icon="/navigation_icons/co-manager.svg"
          onClick={() => navigate(CO_MANAGER_PATH)}
          background="transparent"
          shadowDisabled
          width="36px"
          height="36px"
          padding="8px"
          borderRadius={10}
        />
      </div>
    </KTooltip>
  )
}

export default CoManagerButton
